module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group--three-columns acceptables-grid"
  }, _vm._l((_vm.acceptablesSetting), function(item, index) {
    return (_vm.acceptablesSetting.length >= 1) ? _c('div', {
      staticClass: "form-row"
    }, [_c('el-form-item', {
      staticClass: "item-checkbox"
    }, [_c('el-checkbox', {
      attrs: {
        "checked": item.prohibited,
        "disabled": !_vm.overridden || _vm.readOnly
      },
      on: {
        "change": function($event) {
          _vm.updateSettings()
        }
      },
      model: {
        value: (item.enabled),
        callback: function($$v) {
          _vm.$set(item, "enabled", $$v)
        },
        expression: "item.enabled"
      }
    }, [_vm._v("\n        " + _vm._s(parseFloat(item.denomination.value).toFixed(2)) + "\n        ")])], 1)], 1) : _vm._e()
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ab1b2646!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dq-ui/packages/acceptablespanel/src/acceptablespanel.vue
// module id = 515
// module chunks = 36